import Vue from 'vue';
import auth from './auth';

const state = {
  updatedPlayer: null,
  roomId: null,
};

const actions = {
  SUBSCRIBE: async ({ commit }, { pathId, kuzzle, index }) => {
    if (!index || !pathId) {
      return;
    }
    const roomId = await kuzzle.realtime.subscribe(
      'players',
      'realtime',
      {
        and: [
          {
            equals: {
              pathId: pathId,
            },
          },
        ],
      },
      (notification) => {
        switch (notification.action) {
          case 'publish':
            commit('UPDATE_PLAYER', notification.result._source);
            break;
        }
      },
      { scope: 'all' }
    );
    commit('SET_ROOM_ID', roomId);
    console.log('subscribe players ok', roomId);
  },
  UNSUBSCRIBE: async ({ commit, state }, kuzzle) => {
    if (state.roomId) {
      await kuzzle.realtime.unsubscribe(state.roomId);
    }
    commit('SET_ROOM_ID', null);
    console.log('unsubscribe ok');
  },
};

const mutations = {
  RESET_PLAYERS: (state) => {
    state.updatedPlayer = null;
  },
  UPDATE_PLAYER: (state, playerPayload) => {
    state.updatedPlayer = playerPayload;
  },
  SET_ROOM_ID: (state, roomId) => {
    state.roomId = roomId;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
